import { render, staticRenderFns } from "./ProductsServices.vue?vue&type=template&id=074d899a&scoped=true"
import script from "./ProductsServices.vue?vue&type=script&lang=js"
export * from "./ProductsServices.vue?vue&type=script&lang=js"
import style0 from "./ProductsServices.scss?vue&type=style&index=0&id=074d899a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d899a",
  null
  
)

export default component.exports